var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcastWidgetDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 49,
    fill: "#1A202C",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 41,
    x: 4,
    y: 4,
    fill: "#28313F",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D2DFFA",
    d: "M57.5 38H47.3a16.6 16.6 0 0 0-.1-2.1h10.3c.2 0 .3 0 .5-.2l.1-.4V12.7l-.1-.4a.6.6 0 0 0-.5-.2h-31c-.2 0-.3 0-.4.2l-.2.4v2.5a37 37 0 0 0-2.2-.2v-2.3a2.7 2.7 0 0 1 2.8-2.7h31c.8 0 1.4.3 2 .8.5.5.8 1.2.8 1.9v22.6c0 .7-.3 1.4-.8 1.9-.6.5-1.2.8-2 .8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#605CFF",
    d: "M33.8 38a1 1 0 0 1-.8-.3c-.2-.2-.3-.4-.3-.7a9 9 0 0 0-8-7.8c-.2 0-.5-.1-.7-.3a1 1 0 0 1-.2-.8c0-.3 0-.5.2-.7.2-.2.5-.3.8-.3 2.7.2 5 1.3 6.9 3.2 1.9 1.8 3 4 3.2 6.7 0 .3 0 .5-.3.7-.2.2-.5.3-.8.3Zm7.5 0a1 1 0 0 1-.8-.3c-.2-.2-.3-.5-.3-.8-.3-4-2-7.4-4.8-10.3A16 16 0 0 0 24.9 22c-.3 0-.6 0-.8-.3a1 1 0 0 1-.3-.7c0-.3 0-.6.4-.8.2-.2.6-.3.9-.3 4.7.4 8.6 2.1 11.9 5.3 3.3 3.3 5 7.1 5.4 11.7l-.3.9a1 1 0 0 1-.8.3Zm-16 0c-.5 0-.8-.2-1.1-.5-.4-.3-.5-.6-.5-1 0-.5.1-.9.5-1.2.3-.3.7-.4 1.1-.4.5 0 .8.1 1.1.4.4.4.5.7.5 1.1 0 .5-.1.8-.5 1.1-.3.3-.7.5-1.1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastWidgetDark);
export default __webpack_public_path__ + "static/media/broadcast-widget-dark.83e4ee812a6eb2dee400398aad55afa7.svg";
export { ForwardRef as ReactComponent };